import React from 'react';
import Reveal, { RevealChild, STAGGER } from '../../../components/motion/Reveal';
import styles from '../Home.module.css';

const SectionMasthead: React.FC<{
  index: string;
  label: string;
  title: React.ReactNode;
  titleId: string;
  subtitle?: string;
}> = ({ index, label, title, titleId, subtitle }) => (
  <Reveal staggerInterval={STAGGER.normal} className={styles.masthead}>
    <RevealChild as="p" className={styles.mastheadEyebrow}>
      <span className={styles.mastheadIndex}>{index}</span>
      <span aria-hidden="true"> · </span>
      {label}
    </RevealChild>
    <RevealChild variant="rule" className={styles.mastheadRule} />
    <RevealChild as="h2" className={styles.mastheadTitle} id={titleId}>
      {title}
    </RevealChild>
    {subtitle && (
      <RevealChild as="p" className={styles.mastheadSubtitle}>
        {subtitle}
      </RevealChild>
    )}
  </Reveal>
);

export default SectionMasthead;
